import {Pipe, PipeTransform} from '@angular/core';
import {TranslateParser, TranslateService} from 'ng2-translate/ng2-translate';
import {ConfigService} from '../services/configuracion/config.service';

@Pipe({
  name: 'myTranslate'
})
export class MyTranslatePipe implements PipeTransform {

  constructor(private translate: TranslateService, private config: ConfigService, public translateParser: TranslateParser) {
  }

  transform(value: any, args?: any) {
    return this.getTranslationInTargetLanguage(value, this.config.defaultLanguage);
  }

  public async getTranslationInTargetLanguage(key: string, language: string, interpolateParams: Object = null) {
    const translatedText =
      await this.translate.getTranslation(language)
                .map( (res) => this.translateParser.interpolate(eval('res.' + key), interpolateParams))
                .toPromise();

    console.log('key: ', key);
    console.log('translatedText: ', translatedText);
    return translatedText.toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/my-translate.pipe.ts